import getUniqueColorsOfProduct from './get-unique-colors-of-product.logic';
export default function isProductColored(variants) {
  const uniqueColors = getUniqueColorsOfProduct(variants);
  return uniqueColors.length > 1;
}